import { DeviceType, WholeState } from './type';

export const getDeviceType = (state: WholeState): DeviceType =>
  state.common.deviceType;

export const isDesktop = (state: WholeState): boolean =>
  state.common.deviceType === 'desktop';
